module.exports = __webpack_public_path__ + "img/teacher9.06e9fab8.webp";